import { useState } from 'react';
import { WorkflowApproversContext } from './context';
export function WorkflowApproversProvider(props) {
    const { children } = props;
    const [selectedApprovers, setSelectedApprovers] = useState([]);
    const selectedApproverIds = selectedApprovers.map((approver) => approver.id);
    const toggleApprover = (approver) => {
        if (selectedApproverIds.includes(approver.id)) {
            setSelectedApprovers(selectedApprovers.filter((a) => a.id !== approver.id));
        }
        else {
            setSelectedApprovers([...selectedApprovers, approver]);
        }
    };
    const value = {
        selectedApprovers,
        selectedApproverIds,
        toggleApprover,
    };
    return <WorkflowApproversContext.Provider value={value}>{children}</WorkflowApproversContext.Provider>;
}
